import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CaptchaState, RootState } from 'types/state'

const initialState: CaptchaState = {
  availableCaptcha: [],
  usedCaptcha: [],
}

export const captchaSlice = createSlice({
  name: 'captcha',
  initialState,
  reducers: {
    addAvailableCaptcha: (state: CaptchaState, action: PayloadAction<string>) => {
      state.availableCaptcha.push(action.payload)
    },
    useAvailableCaptcha: (state: CaptchaState, action: PayloadAction<string>) => {
      state.usedCaptcha.push(action.payload)
      state.availableCaptcha = state.availableCaptcha.filter((captcha) => captcha !== action.payload)
    },
  },
})

export const { addAvailableCaptcha, useAvailableCaptcha } = captchaSlice.actions

export const captchaActions = {
  addAvailableCaptcha,
  useAvailableCaptcha,
}

export const captchaSelectors = {
  firstAvailableCaptcha: (state: RootState) => state.captchaState.availableCaptcha[0],
}

export default captchaSlice.reducer
